import { fetchAuthSession } from 'aws-amplify/auth';

export const getSessionToken = async () => {
  const session = await fetchAuthSession();
  const sessionToken = session.tokens?.idToken?.toString();
  if (!sessionToken) {
    throw new Error('No active session token');
  }
  return sessionToken;
};
